/**
 * Store Space brand colors derived from the logo:
 * - Deep navy wordmark (#001e60)
 * - Red padlock accent (#dc3545)
 */
export const brandColors = {
  navy: '#001e60',
  navyDark: '#001545',
  navyMid: '#0a2248',
  red: '#dc3545',
  redLight: '#f87171',
};

/** Sidebar palette tuned for dark theme + full-color logo on white strip */
export const sidebarColors = {
  background: '#081a38',
  backgroundHover: 'rgba(255, 255, 255, 0.06)',
  border: 'rgba(255, 255, 255, 0.1)',
  text: 'rgba(255, 255, 255, 0.88)',
  textMuted: 'rgba(255, 255, 255, 0.58)',
  logoStrip: '#f4f7fb',
  activeBg: 'rgba(220, 53, 69, 0.16)',
  activeText: '#ffffff',
  activeIcon: brandColors.redLight,
  activeBorder: brandColors.red,
};

export const drawerPaperSx = {
  width: 260,
  boxSizing: 'border-box' as const,
  backgroundColor: sidebarColors.background,
  borderRight: 'none',
  backgroundImage: `linear-gradient(180deg, ${brandColors.navyDark} 0%, ${sidebarColors.background} 48%, #0c2248 100%)`,
};
